import { confirmDialog } from 'primereact/confirmdialog';
export const Confirm = async (accept, reject = ()=>{console.log("REJECT")}, message = "") => {
    confirmDialog({
        message:  `${message}\n\nAre you sure you want to proceed?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        accept,
        reject
    });
}

export const ConfirmCustomMessage = async (accept, reject = ()=>{console.log("REJECT")}, message = "", header="") => {
    confirmDialog({
        message,
        header,
        icon: 'pi pi-exclamation-triangle',
        accept,
        reject
    });
}